
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart2, TrendingUp } from 'lucide-react';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer,
  LineChart,
  Line
} from 'recharts';

// Mock data - replace with API calls in a real app
const visitData = [
  { month: 'Jan', visits: 24 },
  { month: 'Feb', visits: 29 },
  { month: 'Mar', visits: 35 },
  { month: 'Apr', visits: 42 },
  { month: 'May', visits: 0 },
  { month: 'Jun', visits: 0 },
];

const revenueData = [
  { month: 'Jan', revenue: 2400 },
  { month: 'Feb', revenue: 2900 },
  { month: 'Mar', revenue: 3500 },
  { month: 'Apr', revenue: 4200 },
  { month: 'May', revenue: 0 },
  { month: 'Jun', revenue: 0 },
];

const AdminOverview: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-lg flex items-center gap-2">
              <BarChart2 className="h-5 w-5 text-primary" />
              Monthly Service Visits
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="h-[300px] w-full">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={visitData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="visits" fill="#1B4D4B" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-lg flex items-center gap-2">
              <TrendingUp className="h-5 w-5 text-primary" />
              Monthly Revenue
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="h-[300px] w-full">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={revenueData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis />
                  <Tooltip formatter={(value) => [`$${value}`, 'Revenue']} />
                  <Line 
                    type="monotone" 
                    dataKey="revenue" 
                    stroke="#F4854B" 
                    strokeWidth={2} 
                    dot={{ stroke: '#F4854B', strokeWidth: 2, r: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Recent Activity</CardTitle>
        </CardHeader>
        <CardContent className="pt-4">
          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex items-center justify-between pb-4 border-b last:border-0">
                <div className="flex flex-col">
                  <span className="font-medium">
                    {['Visit completed', 'New booking', 'Technician added', 'Zone updated', 'Visit rescheduled'][i % 5]}
                  </span>
                  <span className="text-sm text-muted-foreground">
                    {['2 hours ago', '1 day ago', '2 days ago', '3 days ago', '1 week ago'][i % 5]}
                  </span>
                </div>
                <div className="text-sm text-muted-foreground">
                  By Admin
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminOverview;
